import { api } from './client';

export interface MetricDescription {
  found: boolean;
  metric_name?: string;
  description?: string;
  metric_owner?: string;
  warehouse_owner?: string;
}

export interface MetricDescriptionAvailability {
  names: string[];
}

export const metricDescriptionApi = {
  get: (name: string) => api.get<{ code: number; data: MetricDescription }>('/metrics/description', { params: { name } }),
  listAvailable: () => api.get<{ code: number; data: MetricDescriptionAvailability }>('/metrics/descriptions'),
};
